module.exports = __webpack_public_path__ + "media/images/prepaid-3-0f52b5bc45503ad0fc9fa0d02356ae32.png";